module.exports = __webpack_public_path__ + "fonts/subset-mBank-BoldItalic.662c77d5.woff";